import IconClipboard from '@apollo/icons/small/IconClipboard.svg';
import {
  Accordion,
  AccordionHeader,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  AccordionTitle,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardHeaderControl,
  Group,
  List,
  Tooltip,
} from '@apollo/orbit';
import copy from 'copy-to-clipboard';
import React from 'react';

import { DescriptionTermListItem } from '../components/DescriptionTermListItem';
import { HeadersList } from '../components/HeadersList';
import { ConnectorsDebuggingRequest } from '../shared';

interface Props {
  request: ConnectorsDebuggingRequest;
}

export const RequestOverview = ({ request }: Props) => {
  const { url, headers = [], method, body } = request;
  const curlString = [
    `curl --request ${method}`,
    ...headers.map(([key, value]) => `  --header '${key}: ${value}'`),
    `  --url '${url}'`,
    ...(body?.content
      ? [
          `  --data '${
            body.kind === 'json' ? JSON.stringify(body.content) : body.content
          }'`,
        ]
      : []),
  ].join('\\\n');

  return (
    <Card variant="unstyled">
      <CardHeader>
        <CardHeaderControl>
          <Tooltip label="Copy request as a cURL command">
            <Button
              size="xs"
              onClick={() => {
                copy(curlString);
              }}
              leftIcon={<IconClipboard />}
              title="Copy as cURL"
            >
              <span className="!hidden font-mono md:!inline">cURL</span>
            </Button>
          </Tooltip>
        </CardHeaderControl>
      </CardHeader>
      <CardBody className="p-0">
        <Accordion allowMultiple defaultIndex={[0]}>
          <AccordionItem>
            <AccordionHeader>
              <Group align="start">
                <AccordionIcon />
                <AccordionTitle>General</AccordionTitle>
              </Group>
            </AccordionHeader>
            <AccordionPanel className="overflow-auto">
              <List as="dl">
                <DescriptionTermListItem term="URL" details={url} />
                <DescriptionTermListItem
                  term="Request method"
                  details={method}
                />
              </List>
            </AccordionPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionHeader>
              <Group align="start">
                <AccordionIcon />
                <AccordionTitle>
                  Request headers ({headers.length})
                </AccordionTitle>
              </Group>
            </AccordionHeader>
            <AccordionPanel className="overflow-auto">
              <HeadersList headers={headers} />
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </CardBody>
    </Card>
  );
};
